import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import * as actionTypes from './action-types';
import ManageAssignedCourse from '../../components/manage-assigned-course/manage-assigned-course';

class ManageAssignedCourses extends Component {
    static propTypes = {
        isYearGroupDataLoaded: PropTypes.bool,
        isClassroomDataLoaded: PropTypes.bool,
        selectedProduct: PropTypes.object,
        fetchingCourse: PropTypes.bool,
        dispatch: PropTypes.func.isRequired,
        assigningCourses: PropTypes.bool
    }

    componentDidMount() {
        const { selectedProduct, dispatch } = this.props;
        dispatch({ type: actionTypes.GET_YEAR_GROUPS_REQUEST });
        dispatch({
            type: actionTypes.GET_CLASSROOMS_REQUEST,
            productId: selectedProduct.id,
            isClassroomDataLoaded: false
        });
    }

    componentWillReceiveProps(nextProps) {
        const { dispatch } = this.props;
        const { selectedProduct, isYearGroupDataLoaded, isClassroomDataLoaded } = nextProps;

        if (!isYearGroupDataLoaded && isYearGroupDataLoaded !== this.props.isYearGroupDataLoaded) {
            dispatch({ type: actionTypes.GET_YEAR_GROUPS_REQUEST });
        }

        if (!isClassroomDataLoaded && isClassroomDataLoaded !== this.props.isClassroomDataLoaded) {
            dispatch({
                type: actionTypes.GET_CLASSROOMS_REQUEST,
                productId: selectedProduct.id,
                isClassroomDataLoaded: false
            });
        }
    }

    checkCommonTasks = (data) => {
        if (!data.UPF) {
            this.props.dispatch({
                type: actionTypes.CHECK_COMMON_TASKS_REQUEST,
                classroomId: data.classroomId,
                groupId: data.groupId,
                courseId: data.courseId
            });
        } else {
            this.props.dispatch({ type: actionTypes.SET_ASSIGN_UPF_COURSE, payload: { id: data.courseId } });
        }
    }

    saveAssignCourses = (changeCourseRequests) => {
        this.props.dispatch({ type: actionTypes.ASSIGN_COURSES_REQUEST, changeCourseRequests });
    }

    hideCourseDetails = () => {
        this.props.dispatch({ type: actionTypes.HIDE_COURSE_DETAILS });
    }

    render() {
        const { fetchingCourse, isYearGroupDataLoaded, isClassroomDataLoaded } = this.props;
        const isFetching = (!isYearGroupDataLoaded || !isClassroomDataLoaded || fetchingCourse);
        return (<ManageAssignedCourse
            fetching={isFetching}
            {...this.props}
            handleOnAssign={this.checkCommonTasks}
            handleOnSaveAssignCourses={this.saveAssignCourses}
            hideCourseDetails={this.hideCourseDetails}
        />);
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        selectedProduct: state.product,
        yearGroups: state.schoolRoll.yearGroups,
        classrooms: state.classRoll.classrooms,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        assignedTasksId: state.assignCourseAdmin.assignedTasksId,
        upfCourseId: state.assignCourseAdmin.upfCourseId,
        showAssignErrorModal: state.assignCourseAdmin.showAssignErrorModal,
        showSaveErrorModal: state.assignCourseAdmin.showSaveErrorModal,
        activateModal: state.assignCourseAdmin.activateModal,
        assigningCourses: state.assignCourseAdmin.assigningCourses,
        isAssignEvent: state.assignCourseAdmin.isAssignEvent,
        courseDetails: state.assignCourseAdmin.courseDetails,
        isCourseModalVisible: state.assignCourseAdmin.isCourseModalVisible,
        fetchingCourse: state.assignCourseAdmin.fetchingCourse,
        defaultCourses: state.assignCourseAdmin.defaultCourses
    };
}

export default injectIntl(connect(mapStateToProps)(ManageAssignedCourses));



// WEBPACK FOOTER //
// ./app/containers/manage-assigned-courses/manage-assigned-courses.js